import styled, { keyframes } from 'styled-components';

import registerBackground from '../../assets/register-background.png';
import ButtonLoading from '../../components/ButtonLoading';
import Button from '../../components/Button';

interface ContentProps {
  isWiderVersion: boolean;
}

export const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: stretch;

  min-height: 100vh;
`;

export const AnimatedContainer = styled.div`
  animation: ${appearFromLeft} 1s;
  height: 100%;

  > h1 {
    color: ${props => props.theme.colors.grey};
    margin-bottom: 16px;
    margin-top: 56px;
    font-weight: 600;
    font-size: 30px;
  }

  > p {
    color: ${props => props.theme.colors.grey2};
    font-size: 15px;
    line-height: 130%;
    margin-bottom: 35px;
  }

  form {
    > div {
      & + div {
        margin-top: 35px;
      }
    }
  }
`;

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: ${({ isWiderVersion }) => (isWiderVersion ? '50vw' : '650px')};
  margin-bottom: 50px;

  > div {
    width: 100%;
    max-width: 590px;
    margin: 50px auto 0;
    padding: 0 10px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  button {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 50px;
    width: 50px;
    background: none;
    color: ${props => props.theme.colors.primary};
    border: 1px solid ${props => props.theme.colors.primary};
    border-radius: 50px;
  }
`;

export const ButtonLoadingForm = styled(ButtonLoading)`
  margin-top: 50px;
  max-width: 200px;
`;

export const ButtonForm = styled(Button)`
  margin-top: 50px;
  max-width: 200px;
`;

export const Background = styled.div`
  flex: 1;
  background: url(${registerBackground}) no-repeat center;
  background-size: cover;
  background-attachment: fixed;

  div {
    width: 100%;
    height: 100%;

    background: linear-gradient(316.13deg, #2d9cdb -2.05%, #305be5 53.02%);
    opacity: 0.8;
  }
`;

export const CheckboxLineForm = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-left: 10px;
    font-size: 15px;

    a {
      font-weight: 600;
      color: ${props => props.theme.colors.primary};
      text-decoration: none;
      margin: 0 4px;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-weight: 500;
    font-size: 15px;
    color: ${props => props.theme.colors.grey1};

    a {
      text-decoration: none;

      b {
        color: ${props => props.theme.colors.darkBlue2};
      }
    }
  }
`;

export const FormContainer = styled.div`
  > p {
    color: ${props => props.theme.colors.grey2};
    font-size: 15px;
    line-height: 130%;
    margin-bottom: 35px;
  }

  max-width: 450px;
`;
